import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function ProtectedRoute({ requireAdmin = false }) {
  // 仅按本地是否有 token 放行，暂不考虑过期与角色
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  if (!token) {
    return <Navigate to="/login" />;
  }

  // 忽略 requireAdmin 与 isAdmin 判定，直接放行到子路由
  return <Outlet />;
}

export default ProtectedRoute; 